import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const CursorPointerIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="cursorPointer" ref={ref} {...props}>
    <path d="M20.29,13,8,1.12a.75.75,0,0,0-1.27.54V18.28a.76.76,0,0,0,.45.69A.76.76,0,0,0,8,18.82l2.69-2.59,2.58,6a.75.75,0,0,0,.69.45.8.8,0,0,0,.3-.06L17.93,21a.7.7,0,0,0,.4-.41.75.75,0,0,0,0-.57l-2.49-5.8h3.94a.75.75,0,0,0,.7-.47A.74.74,0,0,0,20.29,13Zm-5.42-.21a.68.68,0,0,0-.35.09l-.1,0a.76.76,0,0,0-.39,1L16.65,20,14.3,21l-2.61-6.1a.57.57,0,0,0-.08-.13.65.65,0,0,0-.17-.3.75.75,0,0,0-1.06,0l-2.2,2.11V3.42l9.73,9.34Z" />
  </Icon>
)) as IconWithRender;

CursorPointerIcon.displayName = 'CursorPointerIcon';
CursorPointerIcon.renderIcon = (props) => <CursorPointerIcon {...props} />;
export default CursorPointerIcon;
